app.config(function ($translateProvider) {
    $translateProvider.translations('en-gb', {
        SITE_ASSOCIATE_TYPE: 'Site Associate Type',
        ASSOCIATE_TYPE_LIST: 'Associate Type List',
        ASSOCIATE_TYPE_USER_LIST: '{{ ::user.name }} - Site Associate Types ({{ ::displayedAssociateTypesCount }})',
        ASSOCIATE_TYPE_USER_LIST_ITEM: 'ID {{ ::associateType.id }} - {{ ::associateType.name }}',
        SITE_ASSOCIATE_USER: 'Site Associate User',
        SITE_ASSOCIATE_TYPES:           'Site Associate Types',
        SITE_ASSOCIATE_TYPE_INFORMATION:'Site Associate Type Information',
        ADD_NEW_SITE_ASSOCIATE_TYPE:    'Add a new Site Associate Type',
        EDIT_SITE_ASSOCIATE_TYPE:       'Edit Site Associate Type',

        SITE_ASSOCIATE_TYPE_LIST: 'Site Associate Types',
        SITE_ASSOCIATE_TYPE_ADD: 'Add a new Site Associate Type',
        SITE_ASSOCIATE_TYPE_EDIT: 'Edit Site Associate Type',
        SELECT_ASSOCIATE_TYPES: 'Select Associate Types',

        SITE_ASSOCIATE_TYPE_CREATED: 'Site Associate Type Created',
        SITE_ASSOCIATE_TYPE_UPDATED: 'Site Associate Type Updated',
        SITE_ASSOCIATE_TYPE_DELETED: 'Site Associate Type Deleted',
        SITE_ASSOCIATE_TYPE_REMOVED: 'Site Associate Type Removed ({{ ::associateTypes.length }})',

        ASSOCIATES: 'Associates',
        SITE_ASSOCIATES: 'Site Associates',
        SITE_ASSOCIATE_LIST: 'Site Associates',

        NO_ASSOCIATES_ADDED: 'No Associates Selected',
        CANNOT_DELETE_TYPE: 'This Type Cannot Be Deleted',
        SELECT_HIERARCHY: 'Select Hierarchy',
        HIERARCHY_PRIMARY: 'Primary',
        HIERARCHY_SECONDARY: 'Secondary',
        HIERARCHY_TERTIARY: 'Tertiary',
        HIERARCHY_LAST: 'Last',
        PLEASE_SELECT_HIERARCHY: 'Please select Hierarchy',
        PLEASE_SELECT_SITE: 'Please select Site',
        DESELECT_ALL: 'Deselect All',
        SELECT_ALL: 'Select all',
        SITE_ASSOCIATIONS_SELECT_ALL: 'Select All',
        REMOVAL_WARNING: 'This will remove the selected user associations from all sites and cannot be undone.',
        ARE_YOU_SURE_SHORT: 'Are you sure?',
        REASSIGN_USER_ASSOCIATES_LIST: '{{ ::user.name }} - Reassign Site Associates',
        REASSIGN_USER_ASSOCIATES_SUBTITLE: 'Reassign Associates Types from <strong>{{ ::user.name }}</strong> to:',
        REASSIGN_SELECTED: 'Reassign Selected',
        REASSIGN_ASSOCIATE_SUCCESS: 'Site Associations Reassign Successful',
        REASSIGN_ASSOCIATE_CONFIRMATION: 'Reassign Associate Confirmation',
        REASSIGN_ASSOCIATE_CONFIRMATION_BODY: 'By clicking Confirm you will Reassign the selected sites to the following user: <strong>{{ ::selectedAssociate.name }}</strong>.',
        HIERARCHY: 'Hierarchy',
        SITE_ACCESS_CONFIRMATION_MESSAGE: 'Please be aware that user <strong>{{ ::userName }}</strong> doesn\'t have site access and the following will be granted ({{ ::count }}).',
        SITES_WITHOUT_ACCESS_LIST: 'Sites without access',
        SHOW_ALL: 'Show All',
        HIDE_ALL: 'Hide All',
    });
});
